import PropTypes from 'prop-types';

function SceneToggleButton({
    ariaLabel,
    ariaPressed,
    children,
    className,
    disabled,
    onClick,
    title,
}) {
    return (
        <span className="scene-toggle-shell" title={title}>
            <button
                className={className}
                type="button"
                aria-label={ariaLabel}
                aria-pressed={ariaPressed}
                disabled={disabled}
                onClick={onClick}
            >
                {children}
            </button>
        </span>
    );
}

SceneToggleButton.propTypes = {
    ariaLabel: PropTypes.string.isRequired,
    ariaPressed: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
};

SceneToggleButton.defaultProps = {
    ariaPressed: undefined,
    disabled: false,
};

export default SceneToggleButton;
